import IngestionFunnel from '@/features/IngestionFunnel/IngestionFunnel';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const documentsIngestionFunnelSearchSchema = z.object({
    projectId: z.number().optional(),
});

export const Route = createFileRoute('/documents/ingestion-funnel')({
    component: IngestionFunnel,
    validateSearch: documentsIngestionFunnelSearchSchema,
});